module.exports = __webpack_public_path__ + "b9d5cb283a4252ec06ff25d9c6c41279.png";